/**
 * This comment section is copied from code prior to componentization, some points may
 * not be relevant now.
 * user-test-suites is cloned from SimTestSuites.js
 * TODO: Remove admin specific items
 */
class UserTestSuiteController {
    constructor($window, $browser, $location, $localStorage, $uibModal, ngProgressFactory, 
    // TODO: Replace with component modal
    ModalService, toastr, moment, 
    // Add suites for sim
    UtpSimTestSuitesServiceApi, 
    // Add suites for tester
    UtpUserTestSuitesServiceApi, 
    // Get user sim model model
    UtpTestSuitesExServiceApi, SettingsExService, 
    // UserDetailsApi: IUserDetailsApi,
    UserServiceApi, ICSServiceApi, 
    // TODO: See if we want to use .then() for the store and load methods
    StoredItemsService) {
        this.$onInit = () => {
            this.userDetails = null;
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.state = {
                debug: false,
                selectedTester: null,
                selectedSim: null,
                selectedSuite: null,
                editSuite: false,
                editTest: false,
                // Note: this.toggleTesters(true/false) is used to change this and get the data
                showTesters: true,
                userLabel: "",
                showExpiryIcons: false,
                visibleExpirys: "",
                expiryLimit: -1,
                DateFormats: {
                    DateTimeFormat: "",
                    DateFormat: "",
                    TimeFormat: "",
                },
            };
            this.data = {
                sims: [{ Id: -1, Name: "" }],
                testers: [{ Id: -1, Name: "" }],
                testersWithoutSims: null,
                activeSims: [{ Id: -1, Name: "" }],
                availableSims: [{ Id: -1, Name: "" }],
                activeTestSuites: null,
                availableTestSuites: null,
                activeTestCases: [{ Id: -1, Name: "" }],
                excludedTestCases: [{ Id: -1, Name: "" }],
                testSuites: [
                    {
                        ExpiryDate: null,
                        ExpiryClass: "",
                        ExpiryPopUpText: "",
                        Id: -1,
                        Name: "",
                        TestCaseVariableCount: 0,
                        SupportsMultitest: true,
                    },
                ],
            };
            this.traceProgress.start();
            this.SettingsExService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat,
                };
                this.state.showExpiryIcons =
                    appSettings.TestSuiteExpirationVisibleClasses !== "";
                this.state.visibleExpirys = appSettings.TestSuiteExpirationVisibleClasses;
                this.state.expiryLimit = appSettings.TestSuiteExpiryWarningDayLimit;
                this.UserServiceApi.details().then((response) => {
                    this.userDetails = response.data; // setup our user details
                    this.state.userLabel = this.userDetails.IsProjectTester
                        ? "Projects"
                        : "Testers";
                    if (this.userDetails.IsAdmin) {
                        this.toggleTesters(false);
                        return;
                    }
                    if (this.userDetails.IsSupport || this.userDetails.IsProjectTester) {
                        this.toggleTesters(true);
                        return;
                    }
                }, this.loggedOutRedirect);
            }, this.loggedOutRedirect);
        };
        this.loggedOutRedirect = () => {
            this.toastr.error("Please make sure that you are logged in to OTS UTP!");
            this.window.location.href = this.browser.baseHref() + "account/login";
        };
        // TODO: Deprecate if not used
        this.generateStatusColor = (date) => {
            if (date !== undefined && date !== null) {
                const expiryMoment = this.moment(date);
                const today = this.moment();
                let colour = "traffic-success";
                if (today.isAfter(expiryMoment)) {
                    colour = "traffic-danger";
                }
                else if (expiryMoment.diff(today, "days") < this.state.expiryLimit) {
                    colour = "traffic-warning";
                }
                return colour;
            }
            return "";
        };
        this.generatePopUp = (date) => {
            if (date === undefined || date === null) {
                return "LIVE - No Expiry Date";
            }
            const expiryMoment = this.moment(date);
            const expiryDate = expiryMoment.format(this.state.DateFormats.DateFormat);
            const today = this.moment();
            let popupText = "Will expire on ";
            if (today.isAfter(expiryMoment)) {
                popupText = "Expired on ";
            }
            else if (expiryMoment.diff(today, "days") < this.state.expiryLimit) {
                popupText = "Expiring on ";
            }
            return popupText + expiryDate;
        };
        // TODO: Clean this up!!!
        this.generateTestSuitePopups = () => {
            const suites = this.data.testSuites;
            // NOTE: IdNameExpiryResponse has to be extended with more stuff
            _.forEach(suites, (suite) => {
                suite.popupText = this.generatePopUp(suite.ExpiryDate);
                // TODO: Remove as it is never used
                // suite.statusColour = generateStatusColor(suite.ExpiryDate);
                suite.expired = this.moment().isAfter(this.moment(suite.ExpiryDate));
            });
            _.forEach(this.data.availableTestSuites, (suite) => {
                suite.popupText = this.generatePopUp(suite.ExpiryDate);
                // TODO: Remove as it is never used
                //  suite.statusColour = generateStatusColor(suite.ExpiryDate);
                suite.expired = this.moment().isAfter(this.moment(suite.ExpiryDate));
                // }
            });
        };
        // Add User/Sim Test Suite
        this.addTestSuite = (sim, testSuite) => {
            if (this.state.showTesters) {
                this.addUserTestSuite(this.state.selectedTester, sim, testSuite);
            }
            else {
                this.addSimTestSuite(sim, testSuite);
            }
            this.generateTestSuitePopups();
        };
        this.addSimTestSuite = (sim, testSuite) => {
            const req = {
                SimId: sim.Id,
                TestSuiteId: testSuite.Id,
            };
            this.UtpSimTestSuitesServiceApi.addTestSuite(req).then((response) => {
                // Refresh the sim test suites lists
                const etsr = response.data;
                this.renderTestSuites(etsr, testSuite);
            });
        };
        this.removeSimTestSuite = (sim, testSuite) => {
            const req = {
                SimId: sim.Id,
                TestSuiteId: testSuite.Id,
            };
            this.UtpSimTestSuitesServiceApi.removeTestSuite(req).then((response) => {
                const etsr = response.data;
                this.renderTestSuites(etsr, null);
            });
        };
        this.renderTestSuites = (etsr, selectedSuite) => {
            const testSuites = etsr.TestSuites;
            const availableTestSuites = etsr.AvailableTestSuites;
            this.data.testSuites = testSuites;
            this.data.availableTestSuites = availableTestSuites;
            this.generateTestSuitePopups();
            // No suite then select first
            if (!selectedSuite) {
                // Select the first in the list
                if (testSuites.length > 0) {
                    this.selectSuite(this.data.testSuites[0]);
                }
                else {
                    this.data.activeTestCases = [];
                }
            }
            else {
                const suite = _.find(testSuites, {
                    Id: selectedSuite.Id,
                });
                this.selectSuite(suite);
            }
        };
        this.addUserTestSuite = (user, sim, testSuite) => {
            const req = {
                UserId: user.Id,
                SimId: sim.Id,
                TestSuiteId: testSuite.Id,
            };
            this.UtpUserTestSuitesServiceApi.addTestSuite(req).then((response) => {
                // Refresh the user test suites lists
                this.data.testSuites = response.data.TestSuites;
                this.data.availableTestSuites = response.data.AvailableTestSuites;
                this.generateTestSuitePopups();
                const suite = _.find(this.data.testSuites, {
                    Id: testSuite.Id,
                });
                this.selectSuite(suite);
            });
        };
        this.removeUserTestSuite = (user, sim, testSuite) => {
            const req = {
                UserId: user.Id,
                SimId: sim.Id,
                TestSuiteId: testSuite.Id,
            };
            this.UtpUserTestSuitesServiceApi.removeTestSuite(req).then((response) => {
                // Refresh the test suites list
                const data = response.data;
                this.data.testSuites = data.TestSuites;
                this.data.availableTestSuites = data.AvailableTestSuites;
                this.generateTestSuitePopups();
                // Select the first in the list
                if (data.TestSuites.length > 0) {
                    this.selectSuite(data.TestSuites[0]);
                }
                else {
                    this.data.activeTestCases = [];
                }
            });
        };
        // NOTE: Utility function for Admin to confirm remove suite from sim or test from suite
        this.confirm = (item) => {
            const header = `Remove ${item}`;
            const msg = `All users who have been assigned this ${item} will be affected`;
            const modalOptions = {
                actionButtonText: "Yes",
                closeButtonText: "No",
                headerText: header,
                bodyText: msg,
            };
            return this.ModalService.showModal({}, modalOptions);
        };
        this.removeTestSuite = (sim, testSuite) => {
            if (this.state.showTesters) {
                this.removeUserTestSuite(this.state.selectedTester, sim, testSuite);
            }
            else {
                // Admin has to confirm as this will affect all testers
                this.confirm("Test Suite").then(() => {
                    this.removeSimTestSuite(sim, testSuite);
                });
            }
            this.generateTestSuitePopups();
        };
        this.addTestCase = (testCase) => {
            const testerId = this.state.selectedTester.Id;
            const sim = this.state.selectedSim;
            const testSuite = this.state.selectedSuite;
            if (this.state.showTesters) {
                const req = {
                    UserId: testerId,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id,
                };
                this.UtpUserTestSuitesServiceApi.addTestCase(req).then((response) => {
                    const data = response.data;
                    this.data.activeTestCases = data.ActiveTestCases;
                    this.data.excludedTestCases = data.ExcludedTestCases;
                });
            }
            else {
                const req = {
                    UserId: testerId,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id,
                };
                this.UtpSimTestSuitesServiceApi.addTestCase(req).then((response) => {
                    this.data.activeTestCases = response.data.ActiveTestCases;
                    this.data.excludedTestCases = response.data.ExcludedTestCases;
                });
            }
        };
        this.removeTestCase = (testCase) => {
            const testerId = this.state.selectedTester.Id;
            const sim = this.state.selectedSim;
            const testSuite = this.state.selectedSuite;
            const req = {
                UserId: testerId,
                SimId: sim.Id,
                TestSuiteId: testSuite.Id,
                TestCaseId: testCase.Id,
            };
            // Support just removes the test case
            if (this.state.showTesters) {
                const req = {
                    UserId: testerId,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id,
                };
                this.UtpUserTestSuitesServiceApi.removeTestCase(req).then((response) => {
                    this.data.activeTestCases = response.data.ActiveTestCases;
                    this.data.excludedTestCases = response.data.ExcludedTestCases;
                });
                return;
            }
            // Admin has to confirm as this will affect all testers
            this.confirm("Test Case").then(() => {
                // TODO: Refactor to removeTestCase
                const req = {
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id,
                };
                this.UtpSimTestSuitesServiceApi.removeTestCase(req).then((response) => {
                    const data = response.data;
                    this.data.activeTestCases = data.ActiveTestCases;
                    this.data.excludedTestCases = data.ExcludedTestCases;
                });
            });
        };
        // Toggle between tester and sim views
        this.toggleTesters = (isShowTesters) => {
            // Reset the state
            this.state.showTesters = isShowTesters;
            this.state.editSuite = false;
            this.state.editTest = false;
            // Retireve any stored selections
            this.StoredItemsService.load().then((response) => {
                const storedItems = response || this.StoredItemsService.unselectedItems();
                // Support has a selected tester
                if (isShowTesters) {
                    const req = {
                        TesterId: storedItems.tester.Id || null,
                        SimId: storedItems.sim.Id || null,
                        SuiteId: storedItems.suite.Id || null,
                    };
                    this.renderUserModel(req).then((response) => {
                        const data = response.data;
                        this.renderAndStoreSelectedItems(data, storedItems);
                    });
                    return;
                }
                // Admin has no selected tester
                const req = {
                    UserId: null,
                    SimId: storedItems.sim.Id || null,
                    SuiteId: storedItems.suite.Id || null,
                    RestoreFullState: true,
                };
                this.renderSimModel(req).then((response) => {
                    const data = response.data;
                    this.renderAndStoreSelectedItems(data, storedItems);
                });
            });
        };
        this.renderAndStoreSelectedItems = (data, storedItems) => {
            const unselectedItem = this.StoredItemsService.unselectedItem();
            this.state.selectedTester =
                storedItems.tester.Id > 0
                    ? this.getItemById(data.Testers, storedItems.tester.Id)
                    : this.data.testers && this.data.testers.length > 0
                        ? this.data.testers[0]
                        : unselectedItem;
            const testerIdName = {
                Id: this.state.selectedTester.Id,
                Name: this.state.selectedTester.Name,
            };
            this.StoredItemsService.storeTester(testerIdName);
            this.state.selectedSim =
                storedItems.sim.Id > 0
                    ? this.getItemById(data.Sims, storedItems.sim.Id)
                    : this.data.sims && this.data.sims.length > 0
                        ? this.data.sims[0]
                        : unselectedItem;
            const simIdName = {
                Id: this.state.selectedSim.Id,
                Name: this.state.selectedSim.Name,
            };
            this.StoredItemsService.storeSim(simIdName);
            this.state.selectedSuite =
                storedItems.suite.Id > 0
                    ? this.getItemById(data.TestSuites, storedItems.suite.Id)
                    : this.data.testSuites && this.data.testSuites.length > 0
                        ? this.data.testSuites[0]
                        : unselectedItem;
            const suiteIdName = {
                Id: this.state.selectedSuite.Id,
                Name: this.state.selectedSuite.Name,
            };
            this.StoredItemsService.storeSuite(suiteIdName);
        };
        this.renderUserModel = (req) => {
            if (this.userDetails.IsProjectTester) {
                return this.UtpTestSuitesExServiceApi.getProjectTesterUserModel(req).then((response) => {
                    const data = response.data;
                    this.data = {
                        sims: data.Sims,
                        testers: data.Testers,
                        activeTestCases: data.ActiveTestCases,
                        excludedTestCases: data.ExcludedTestCases,
                        availableTestSuites: data.AvailableTestSuites,
                        testSuites: data.TestSuites,
                        testersWithoutSims: this.data.testersWithoutSims,
                        activeSims: this.data.activeSims,
                        activeTestSuites: this.data.activeTestSuites,
                        availableSims: this.data.availableSims,
                    };
                    this.generateTestSuitePopups();
                    return response;
                });
            }
            else {
                return this.UtpTestSuitesExServiceApi.getUserModel(req).then((response) => {
                    const data = response.data;
                    this.data = {
                        sims: data.Sims,
                        testers: data.Testers,
                        activeTestCases: data.ActiveTestCases,
                        excludedTestCases: data.ExcludedTestCases,
                        availableTestSuites: data.AvailableTestSuites,
                        testSuites: data.TestSuites,
                        testersWithoutSims: this.data.testersWithoutSims,
                        activeSims: this.data.activeSims,
                        activeTestSuites: this.data.activeTestSuites,
                        availableSims: this.data.availableSims,
                    };
                    this.generateTestSuitePopups();
                    return response;
                });
            }
        };
        this.renderSimModel = (req) => {
            // Initialise the view model for the sims
            return this.UtpSimTestSuitesServiceApi.getSimModel(req.SimId, req.SuiteId).then((response) => {
                const data = response.data;
                this.data = {
                    sims: data.Sims,
                    testers: data.Testers,
                    activeTestCases: data.ActiveTestCases,
                    excludedTestCases: data.ExcludedTestCases,
                    availableTestSuites: data.AvailableTestSuites,
                    testSuites: data.TestSuites,
                    testersWithoutSims: this.data.testersWithoutSims,
                    activeSims: this.data.activeSims,
                    activeTestSuites: this.data.activeTestSuites,
                    availableSims: this.data.availableSims,
                };
                this.generateTestSuitePopups();
                // TODO: Do we even need this?
                this.state.selectedTester = null;
                // // TODO: Do we need to handle cases where there are no items
                // this.state.selectedSim = data.Sims[0];
                // this.state.selectedSuite = data.TestSuites[0];
                return response;
            });
        };
        this.getItemById = (collection, id) => {
            const ret = _.find(collection, ["Id", id]);
            return ret;
        };
        this.supportSelectedTester = () => {
            // Make sure we have a valid tester
            if (this.state.selectedTester === null ||
                this.state.selectedTester.Id === 0) {
                const msg = "Invalid Tester: " + this.state.selectedTester;
                this.toastr.warning(msg);
                return;
            }
            // TODO: Store tester, sim, suite
            const tester = this.state.selectedTester;
            const sim = this.state.selectedSim;
            const suite = this.state.selectedSuite;
            const storedItems = {
                tester: tester,
                sim: sim,
                suite: suite,
                test: this.StoredItemsService.unselectedItem(),
            };
            this.StoredItemsService.save(storedItems).then(() => {
                this.UserServiceApi.getUser(this.state.selectedTester.Id).then((response) => {
                    let tester = response.data;
                    if (tester.IsGroupTester) {
                        let gtRoute = "/GtHome/" + tester.Id;
                        this.location.path(gtRoute);
                        return;
                    }
                    if (tester.IsDataValidator) {
                        let dvRoute = "/DataValidator/" + tester.Id;
                        this.location.path(dvRoute);
                        return;
                    }
                    let route = "/Home/" + this.state.selectedTester.Id;
                    this.location.path(route);
                });
            });
        };
        // Populate view model with new data
        // TODO: Comprehend when we have Sims/Suites=0 => unselectedItem
        this.populateModel = (tester, sim, suite, newData) => {
            // If anything is missing then replace with unselectedItem
            // const unselectedItem = StoredItemsService.unselectedItem();
            // let testerOrDefault =
            //     newData.Testers.length > 0 ? tester : unselectedItem;
            // let simOrDefault = newData.Sims.length > 0 ? sim : unselectedItem;
            // let suiteOrDefault =
            //     newData.TestSuites.length > 0 ? suite : unselectedItem;
            // Populate the model in order of Tests, Suites, then Sims
            // If we select a suite then just populate the tests
            if (suite !== null) {
                // Test Cases
                this.data.activeTestCases = newData.ActiveTestCases;
                this.data.excludedTestCases = newData.ExcludedTestCases;
                /// State
                this.state.selectedSuite = suite;
                // Store our selected items in localStorage
                this.StoredItemsService.storeSuite(suite);
                return;
            }
            // If we select a sim then populate the suites and tests
            if (sim !== null) {
                // Test Suites
                this.data.testSuites = newData.TestSuites;
                this.data.availableTestSuites = newData.AvailableTestSuites;
                this.generateTestSuitePopups();
                // Test Cases
                this.data.activeTestCases = newData.ActiveTestCases;
                this.data.excludedTestCases = newData.ExcludedTestCases;
                // State
                this.state.selectedSim = sim;
                // TODO: Check that we have at least one test suite
                if (newData.TestSuites.length > 0) {
                    this.state.selectedSuite = newData.TestSuites[0];
                }
                else {
                    this.data.activeTestCases = null;
                }
                // Store our selected items in localStorage
                this.StoredItemsService.storeSim(sim);
                const suite = {
                    Id: this.state.selectedSuite.Id,
                    Name: this.state.selectedSuite.Name,
                };
                this.StoredItemsService.storeSuite(suite);
                return;
            }
            // If we select a tester then populate the sims, suites, and tests
            if (tester !== null) {
                // Sims
                this.data.sims = newData.Sims;
                // Test Suites
                this.data.testSuites = newData.TestSuites;
                this.data.availableTestSuites = newData.AvailableTestSuites;
                this.generateTestSuitePopups();
                // Test Cases
                this.data.activeTestCases = newData.ActiveTestCases;
                this.data.excludedTestCases = newData.ExcludedTestCases;
                // State
                this.state.selectedTester = tester;
                if (newData.Sims.length > 0) {
                    this.state.selectedSim = newData.Sims[0];
                }
                if (newData.TestSuites.length > 0) {
                    this.state.selectedSuite = newData.TestSuites[0];
                }
                // Store our selected items in localStorage
                this.StoredItemsService.storeTester(tester);
                const sim = this.state.selectedSim;
                this.StoredItemsService.storeSim(sim);
                const suite = {
                    Id: this.state.selectedSuite.Id,
                    Name: this.state.selectedSuite.Name,
                };
                this.StoredItemsService.storeSuite(suite);
                return;
            }
        };
        this.selectTester = (tester) => {
            this.traceProgress.start();
            const req = {
                TesterId: tester.Id,
                SimId: null,
                SuiteId: null,
            };
            this.UtpTestSuitesExServiceApi.getUserModel(req).then((response) => {
                this.traceProgress.complete();
                this.populateModel(tester, null, null, response.data);
            });
        };
        this.supportSelectSim = (sim) => {
            const tester = this.state.selectedTester;
            const req = {
                TesterId: tester.Id,
                SimId: sim.Id,
                SuiteId: null,
            };
            this.UtpTestSuitesExServiceApi.getUserModel(req).then((response) => {
                this.populateModel(tester, sim, null, response.data);
            });
        };
        this.adminSelectSim = (sim) => {
            this.UtpSimTestSuitesServiceApi.getSimModel(sim.Id, null).then((response) => {
                const data = response.data;
                this.populateModel(null, sim, null, data);
            });
        };
        this.selectSim = (sim) => {
            this.state.selectedSim = sim;
            // Support sees a list of users
            if (this.state.showTesters) {
                this.supportSelectSim(sim);
                return;
            }
            // Admin does not see a list of users
            this.adminSelectSim(sim);
        };
        this.supportSelectSuite = (tester, sim, suite) => {
            const req = {
                TesterId: tester.Id,
                SimId: sim.Id,
                SuiteId: suite.Id,
            };
            this.UtpTestSuitesExServiceApi.getUserModel(req).then((response) => {
                const data = response.data;
                this.populateModel(tester, sim, suite, data);
            });
        };
        this.adminSelectSuite = (sim, suite) => {
            const req = {
                UserId: null,
                SimId: sim.Id,
                SuiteId: suite.Id,
                RestoreFullState: true,
            };
            this.UtpSimTestSuitesServiceApi.getSimModel(sim.Id, suite.Id).then((response) => {
                const data = response.data;
                this.populateModel(null, sim, suite, data);
            });
        };
        this.selectSuite = (suite) => {
            const tester = this.state.selectedTester;
            const sim = this.state.selectedSim;
            // NOTE: suite has Expiry, etc
            // const suiteEx: IdNameResponse = { Id: suite.Id, Name: suite.Name };
            // Support sees a list of users
            if (this.state.showTesters) {
                this.supportSelectSuite(tester, sim, suite);
                return;
            }
            // Admin does not see any users
            this.adminSelectSuite(sim, suite);
        };
        this.showEditTest = () => {
            // No ICS available so fallback to old modal dialog
            let modalInstance = this.uibModal.open({
                animation: true,
                component: "uploadTestCasesModal",
                size: "lg",
                backdrop: "static",
                resolve: {
                    selectedItems: () => {
                        return {
                            selectedTester: this.state.selectedTester,
                            selectedSim: this.state.selectedSim,
                            selectedSuite: this.state.selectedSuite,
                            testCases: this.data.activeTestCases,
                            excludedTestCases: this.data.excludedTestCases,
                            showTesters: this.state.showTesters,
                        };
                    },
                },
            });
            modalInstance.result.then((result) => {
                // reload
                this.selectTester(this.state.selectedTester);
                return;
            });
        };
        this.icsModal = () => {
            let userId = this.state.selectedTester.Id;
            let simId = this.state.selectedSim.Id;
            let testSuiteId = this.state.selectedSuite.Id;
            let readOnly = this.userDetails.IsSupport || this.userDetails.IsProjectTester;
            const userName = this.state.selectedTester.Name;
            const simulatorName = this.state.selectedSim.Name;
            const modalInstance = this.uibModal.open({
                animation: true,
                component: "icsQuestionnaireModal",
                size: "lg",
                backdrop: "static",
                resolve: {
                    userId: () => {
                        return userId;
                    },
                    simId: () => {
                        return simId;
                    },
                    testSuiteId: () => {
                        return testSuiteId;
                    },
                    readOnly: () => {
                        return readOnly;
                    },
                    userName: () => {
                        return userName;
                    },
                    simulatorName: () => {
                        return simulatorName;
                    },
                },
            });
            modalInstance.result.then((result) => {
                // Assign returned data to active and excluded test cases
                // this.data.activeTestCases = result.ActiveTestCases;
                // this.data.excludedTestCases = result.ExcludedTestCases;
                // return;
            });
        };
        this.editTestInstructions = (paramSuite) => {
            // Transform the IdName to the suite interface
            let suite = {};
            suite.Id = paramSuite.Id;
            suite.TestSuiteName = paramSuite.Name;
            suite.expiryClass = paramSuite.ExpiryClass;
            const suiteEditModal = this.uibModal.open({
                backdrop: "static",
                animation: true,
                component: "editTestCaseComponent",
                size: "md",
                resolve: {
                    suite: () => {
                        return suite;
                    },
                    visibleExpirys: () => {
                        return this.state.visibleExpirys;
                    },
                },
            });
            suiteEditModal.result.then(() => {
                // TODO: Refresh test cases with TestInfo interface
                // TODO: We need to add a service call and change the test cases display
            });
        };
        this.window = $window;
        this.location = $location;
        this.localStorage = $localStorage;
        this.browser = $browser;
        this.uibModal = $uibModal;
        this.ngProgressFactory = ngProgressFactory;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.moment = moment;
        this.UtpUserTestSuitesServiceApi = UtpUserTestSuitesServiceApi;
        this.UtpSimTestSuitesServiceApi = UtpSimTestSuitesServiceApi;
        this.UtpTestSuitesExServiceApi = UtpTestSuitesExServiceApi;
        // this.StateService = StateService;
        this.SettingsExService = SettingsExService;
        this.UserServiceApi = UserServiceApi;
        this.StoredItemsService = StoredItemsService;
        // this.UserDetailsApi = UserDetailsApi;
        this.ICSServiceApi = ICSServiceApi;
    }
}
angular.module("app").component("userTestSuites", {
    bindings: {},
    templateUrl: "scripts/app/partials/ProvisionSim/user-test-suites.tpl.html",
    controllerAs: "vm",
    controller: UserTestSuiteController,
});
